export default {
  name: 'TheFooter',
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
};